"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefAuditReasonKey = exports.RefAuditCategory = exports.RefAuditAction = void 0;
var RefAuditAction;
(function (RefAuditAction) {
    RefAuditAction["Create"] = "CREATE";
    RefAuditAction["Update"] = "UPDATE";
    RefAuditAction["Delete"] = "DELETE";
    RefAuditAction["Read"] = "READ";
})(RefAuditAction = exports.RefAuditAction || (exports.RefAuditAction = {}));
var RefAuditCategory;
(function (RefAuditCategory) {
    // Auth
    RefAuditCategory["Auth_User"] = "AUTH::USER";
    RefAuditCategory["Auth_Organization"] = "AUTH::ORGANIZATION";
    RefAuditCategory["Auth_Role"] = "AUTH::ROLE";
    RefAuditCategory["Auth_Notification"] = "AUTH::NOTIFICATION";
    RefAuditCategory["Auth_DictionaryLicense"] = "AUTH::DICTIONARY_LICENSE";
    // SSO
    RefAuditCategory["SSO_AuthToken"] = "SSO::AUTH_TOKEN";
    RefAuditCategory["SSO_RequestToken"] = "SSO::REQUEST_TOKEN";
    RefAuditCategory["SSO_Notification"] = "SSO::NOTIFICATION";
    RefAuditCategory["SSO_UserNotification"] = "SSO::USER_NOTIFICATION";
    RefAuditCategory["SSO_UserDevice"] = "SSO::USER_DEVICE";
    // Billing
    RefAuditCategory["Billing_Package"] = "BILLING::PACKAGE";
    RefAuditCategory["Billing_Subscription"] = "BILLING::SUBSCRIPTION";
    RefAuditCategory["Billing_Purchase"] = "BILLING::PURCHASE";
    RefAuditCategory["Billing_NotificationMail"] = "BILLING::NOTIFICATION_MAIL";
    RefAuditCategory["Billing_SubscriptionStatusNoti"] = "BILLING::SUBSCRIPTION_STATUS_NOTI";
    // Docs
    RefAuditCategory["Docs_FolderFile_View"] = "DOCS::FOLDER_FILE_VIEW";
    RefAuditCategory["Docs_FolderFile_Download"] = "DOCS::FOLDER_FILE_DOWNLOAD";
    RefAuditCategory["Docs_Folder_Signer_Download"] = "DOCS::FOLDER_SIGNER_DOWNLOAD";
    // Builder
    RefAuditCategory["Builder_StudyInfo"] = "BUILDER::STUDY_INFO";
    RefAuditCategory["Builder_StudyDraftPayload"] = "BUILDER::STUDY_DRAFT_PAYLOAD";
    RefAuditCategory["Builder_StudyPublishedPayload"] = "BUILDER::STUDY_PUBLISHED_PAYLOAD";
    RefAuditCategory["Builder_StudyTemplateCrfVersion"] = "BUILDER::STUDY_TEMPLATE_CRF_VERSION";
    // Builder Property (Settings)
    RefAuditCategory["Builder_StudyGeneralProperty"] = "BUILDER::STUDY_GENERAL_PROPERTY";
    RefAuditCategory["Builder_StudySubjectColumnsProperty"] = "BUILDER::STUDY_SUBJECT_COLUMNS_PROPERTY";
    RefAuditCategory["Builder_StudyEngineVersionProperty"] = "BUILDER::STUDY_ENGINE_VERSION_PROPERTY";
    RefAuditCategory["Builder_StudyBlankCrfHeaderProperty"] = "BUILDER::STUDY_BLANK_CRF_HEADER_PROPERTY";
    RefAuditCategory["Builder_StudyBlankCrfCoverProperty"] = "BUILDER::STUDY_BLANK_CRF_COVER_PROPERTY";
    RefAuditCategory["Builder_StudyUatCoverProperty"] = "BUILDER::STUDY_UAT_COVER_PROPERTY";
    RefAuditCategory["Builder_StudyEcoaConfigTwoFactorAuth"] = "BUILDER::STUDY_ECOA_CONFIG_TWO_FACTOR_AUTH";
    RefAuditCategory["Builder_StudyEcoaConfigNotice"] = "BUILDER::STUDY_ECOA_CONFIG_NOTICE";
    RefAuditCategory["Builder_StudyEcoaConfigNoticePerPage"] = "BUILDER::STUDY_ECOA_CONFIG_NOTICE_PER_PAGE";
    RefAuditCategory["Builder_StudyEcoaConfigNoticeContent"] = "BUILDER::STUDY_ECOA_CONFIG_NOTICE_CONTENT";
    RefAuditCategory["Builder_StudyEcoaConfigPopupTitle"] = "BUILDER::STUDY_ECOA_CONFIG_POPUP_TITLE";
    RefAuditCategory["Builder_StudyEcoaConfigPopupContent"] = "BUILDER::STUDY_ECOA_CONFIG_POPUP_CONTENT";
    RefAuditCategory["Builder_StudyEcoaConfigMisc"] = "BUILDER::STUDY_ECOA_CONFIG_POPUP_MISC";
    RefAuditCategory["Builder_StudyEcoaConfigFontCTR"] = "BUILDER::STUDY_ECOA_CONFIG_FONT_CONTROLLER";
    RefAuditCategory["Builder_StudyPayloadFolder"] = "BUILDER::STUDY_PAYLOAD_FOLDER";
    RefAuditCategory["Builder_StudyPayloadPage"] = "BUILDER::STUDY_PAYLOAD_PAGE";
    RefAuditCategory["Builder_StudyPayloadVisit"] = "BUILDER::STUDY_PAYLOAD_VISIT";
    RefAuditCategory["Builder_StudyPayloadSection"] = "BUILDER::STUDY_PAYLOAD_SECTION";
    RefAuditCategory["Builder_StudyPayloadPageSectionItem"] = "BUILDER::STUDY_PAYLOAD_PAGE_SECTION_ITEM";
    RefAuditCategory["Builder_StudyPayloadScheduleMatrix"] = "BUILDER::STUDY_PAYLOAD_SCHEDULE_MATRIX";
    RefAuditCategory["Builder_StudyPayloadDomain"] = "BUILDER::STUDY_PAYLOAD_DOMAIN";
    RefAuditCategory["Builder_StudyRole"] = "BUILDER::STUDY_ROLE";
    RefAuditCategory["Builder_StudyRolePrivilege"] = "BUILDER::STUDY_ROLE_PRIVILEGE";
    RefAuditCategory["Builder_StudyMedicalCoding"] = "BUILDER::STUDY_MEDICAL_CODING";
    RefAuditCategory["Builder_StudyMedicalCodingColumn"] = "BUILDER::STUDY_MEDICAL_CODING_COLUMN";
    /** @deprecated CDMS_StudySite 사용 요망 */
    RefAuditCategory["Builder_StudySite"] = "BUILDER::STUDY_SITE";
    RefAuditCategory["Builder_StudySiteEnvironment"] = "BUILDER::STUDY_SITE_ENVIRONMENT";
    RefAuditCategory["Builder_StudyDashboardConfig"] = "BUILDER::STUDY_DASHBOARD_CONFIG";
    RefAuditCategory["Builder_StudyDashboardConfigSubjectStatus"] = "BUILDER::STUDY_DASHBOARD_CONFIG_SUBJECT_STATUS";
    RefAuditCategory["Builder_StudyDashboardConfigSite"] = "BUILDER::STUDY_DASHBOARD_CONFIG_SITE";
    RefAuditCategory["Builder_StudyStatusCaptureStatus"] = "BUILDER::STUDY_STATUS_CAPTURE_STAT";
    RefAuditCategory["Builder_StudyLabTestItem"] = "BUILDER::STUDY_LAB_TEST_ITEM";
    RefAuditCategory["Builder_StudyLabTestItemUnit"] = "BUILDER::STUDY_LAB_TEST_ITEM_UNIT";
    RefAuditCategory["Builder_StudyTemplate"] = "BUILDER::STUDY_TEMPLATE";
    RefAuditCategory["Builder_StudyPayloadLabTestItem"] = "BUILDER::STUDY_PAYLOAD_LAB_TEST_ITEM";
    RefAuditCategory["Builder_StudyPayloadLabTestUnit"] = "BUILDER::STUDY_PAYLOAD_LAB_TEST_UNIT";
    RefAuditCategory["Builder_StudyPayloadTrigger"] = "BUILDER::STUDY_PAYLOAD_TRIGGER";
    RefAuditCategory["Builder_StudyPayloadTriggerVersion"] = "BUILDER::STUDY_PAYLOAD_TRIGGER_VERSION";
    RefAuditCategory["Builder_StudyPayloadValidation"] = "BUILDER::STUDY_PAYLOAD_VALIDATION";
    RefAuditCategory["Builder_MemberOrganizationRole"] = "BUILDER::MEMBER_ORGANIZATION_ROLE";
    RefAuditCategory["Builder_OrganizationRole"] = "BUILDER::ORGANIZATION_ROLE";
    RefAuditCategory["Builder_OrganizationRolePrivilege"] = "BUILDER::ORGANIZATION_ROLE_PRIVILEGE";
    RefAuditCategory["Builder_TriggerTargetMapping"] = "BUILDER::TRIGGER_TARGET_MAPPING";
    // Safety
    RefAuditCategory["Safety_Cache"] = "SAFETY::CACHE";
    RefAuditCategory["Safety_Workspace"] = "SAFETY::WORKSPACE";
    RefAuditCategory["Safety_WorkspaceMember"] = "SAFETY::WORKSPACE_MEMBER";
    RefAuditCategory["Safety_WorkspaceRole"] = "SAFETY::WORKSPACE_ROLE";
    RefAuditCategory["Safety_Submission"] = "SAFETY::SUBMISSION";
    RefAuditCategory["Safety_Preset"] = "SAFETY::PRESET";
    RefAuditCategory["Safety_CaseCapture"] = "SAFETY::CASE_CAPTURE";
    RefAuditCategory["Safety_CaseReportImportFile"] = "SAFETY::CASE_REPORT_IMPORT_FILE";
    RefAuditCategory["Safety_SignalDetectionProfile"] = "SAFETY::SIGNAL_DETECTION_PROFILE";
    RefAuditCategory["Safety_SignalDetectionRunHistory"] = "SAFETY::SIGNAL_DETECTION_RUN_HISTORY";
    RefAuditCategory["Safety_SignalDetectionSignal"] = "SAFETY::SIGNAL_DETECTION_SIGNAL";
    RefAuditCategory["Safety_SignalDetectionResult"] = "SAFETY::SIGNAL_DETECTION_RESULT";
    RefAuditCategory["Safety_SignalDetectionWorkflowHistory"] = "SAFETY::SIGNAL_DETECTION_WORKFLOW_HISTORY";
    // CDMS - legacy
    RefAuditCategory["CrfData"] = "CRF:DATA";
    RefAuditCategory["CrfQuery"] = "CRF:QUERY";
    RefAuditCategory["CrfItemSdv"] = "CRF:ITEM:SDV";
    RefAuditCategory["CrfItemFreezing"] = "CRF:ITEM:FREEZING";
    RefAuditCategory["CrfItemLocking"] = "CRF:ITEM:LOCKING";
    RefAuditCategory["CrfItemESign"] = "CRF:ITEM:ESIGN";
    RefAuditCategory["CDMS_CrfItemReview"] = "CDMS::CRF_ITEM_REVIEW";
    RefAuditCategory["CrfSdv"] = "CRF:SDV";
    RefAuditCategory["CrfFreezing"] = "CRF:FREEZING";
    RefAuditCategory["CrfEsign"] = "CRF:ESIGN";
    RefAuditCategory["CrfSecondEsign"] = "CRF:SECOND_ESIGN";
    RefAuditCategory["CrfLocking"] = "CRF:LOCKING";
    RefAuditCategory["CDMS_CrfReview"] = "CDMS::CRF_REVIEW";
    RefAuditCategory["CdmsLabTest"] = "CDMS:LAB_TEST";
    RefAuditCategory["CdmsLabNormalRange"] = "CDMS:LAB_NORMAL_RANGE";
    RefAuditCategory["BuilderRtsmRandomization"] = "BUILDER:RTSM:RANDOMIZATION";
    RefAuditCategory["BuilderRtsmIpm"] = "BUILDER:RTSM:IPM";
    RefAuditCategory["PreSubjectReserved"] = "PRE_SUBJECT:RESERVED";
    // CDMS
    RefAuditCategory["CDMS_StudySite"] = "CDMS::STUDY_SITE";
    RefAuditCategory["CDMS_StudyIndependentEvaluation"] = "CDMS::STUDY_INDEPENDENT_EVALUATION";
    RefAuditCategory["CDMS_StudySafetyIntegrationUser"] = "CDMS::STUDY_SAFETY_INTEGRATION_USER";
    RefAuditCategory["CDMS_StudySubjectEnabled"] = "CDMS::STUDY_SUBJECT:ENABLED";
    RefAuditCategory["CDMS_StudySafetyIntegrationHistory"] = "CDMS::STUDY_SAFETY_INTEGRATION_HISTORY";
    RefAuditCategory["CDMS_StudyCategory"] = "CDMS::STUDY_CATEGORY";
    RefAuditCategory["CDMS_StudyCategoryValue"] = "CDMS::STUDY_CATEGORY_VALUE";
    RefAuditCategory["CDMS_StudySubjectGroup"] = "CDMS::STUDY_SUBJECT_GROUP";
    RefAuditCategory["CDMS_StudyProtocolDeviation"] = "CDMS::STUDY_PROTOCOL_DEVIATION";
    RefAuditCategory["CDMS_StudyProtocolDeviationConfig"] = "CDMS::STUDY_PROTOCOL_DEVIATION_CONFIG";
    RefAuditCategory["CDMS_StudyProtocolDeviationCategory"] = "CDMS::STUDY_PROTOCOL_DEVIATION_CATEGORY";
    RefAuditCategory["CDMS_StudyAttachmentFileUsage"] = "CDMS::STUDY_ATTACHMENT_FILE_USAGE";
    RefAuditCategory["CDMS_StudyAttachmentFileUsageInfo"] = "CDMS::STUDY_ATTACHMENT_FILE_USAGE_INFO";
    RefAuditCategory["CDMS_StudyLabTestStandardUnit"] = "CDMS::STUDY_LAB_TEST_STANDARD_UNIT";
    RefAuditCategory["CDMS_StudyLabTestAlertNotification"] = "CDMS::STUDY_LAB_TEST_ALERT_NOTIFICATION";
    // Admin
    RefAuditCategory["Admin_Notice"] = "ADMIN::NOTICE";
    RefAuditCategory["Admin_Release"] = "ADMIN::RELEASE";
    // X
    RefAuditCategory["X_ProjectTaskAttachmentEsign_Cancel"] = "X::PROJECT_TASK_ATTACHMENT_ESIGN:CANCEL";
    // RTSM
    RefAuditCategory["RTSM_Study"] = "RTSM::STUDY";
    RefAuditCategory["RTSM_StudyRole"] = "RTSM::STUDY_ROLE";
    RefAuditCategory["RTSM_StudyUserRole"] = "RTSM::STUDY_USER_ROLE";
    RefAuditCategory["RTSM_StudyRolePrivilege"] = "RTSM::STUDY_ROLE_PRIVILEGE";
    RefAuditCategory["RTSM_StudyUser"] = "RTSM::STUDY_USER";
    RefAuditCategory["RTSM_StudyUserRoleSite"] = "RTSM::STUDY_USER_ROLE_SITE";
    RefAuditCategory["RTSM_StudyDepot"] = "RTSM::STUDY_DEPOT";
    RefAuditCategory["RTSM_StudyDepotSite"] = "RTSM::STUDY_DEPOT_SITE";
    RefAuditCategory["RTSM_StudySite"] = "RTSM::STUDY_SITE";
    RefAuditCategory["RTSM_StudySubject"] = "RTSM::STUDY_SUBJECT";
    RefAuditCategory["RTSM_StudySubjectCustomData"] = "RTSM::STUDY_SUBJECT_CUSTOM_DATA";
    RefAuditCategory["RTSM_StudyVisitPath"] = "RTSM::STUDY_VISIT_PATH";
    RefAuditCategory["RTSM_StudyRandomizationSetting"] = "RTSM::STUDY_RANDOMIZATION_SETTING";
    RefAuditCategory["RTSM_StudyIpSetting"] = "RTSM::STUDY_IP_SETTING";
    RefAuditCategory["RTSM_RandomStratification"] = "RTSM::RANDOM_STRATIFICATION";
    RefAuditCategory["RTSM_RandomStratificationDetail"] = "RTSM::RANDOM_STRATIFICATION_DETAIL";
    RefAuditCategory["RTSM_RandomGroup"] = "RTSM::RANDOM_GROUP";
    RefAuditCategory["RTSM_RandomIsolation"] = "RTSM::RANDOM_ISOLATION";
    RefAuditCategory["RTSM_RandomCodeUpload"] = "RTSM::RANDOM_CODE_UPLOAD";
    RefAuditCategory["RTSM_RandomCode"] = "RTSM::RANDOM_CODE";
    RefAuditCategory["RTSM_Randomization"] = "RTSM::RANDOMIZATION";
    RefAuditCategory["RTSM_IpCategory"] = "RTSM::IP_CATEGORY";
    RefAuditCategory["RTSM_IpDrug"] = "RTSM::IP_DRUG";
    RefAuditCategory["RTSM_IpSchedule"] = "RTSM::IP_SCHEDULE";
    RefAuditCategory["RTSM_IpCode"] = "RTSM::IP_CODE";
    RefAuditCategory["RTSM_IpCodeChangeStatus"] = "RTSM::IP_CODE_CHANGE_STATUS";
    RefAuditCategory["RTSM_IpCodeDispensedAt"] = "RTSM::IP_CODE_DISPENSED_AT";
    RefAuditCategory["RTSM_IpCodeDispensedQuantity"] = "RTSM::IP_CODE_DISPENSED_QUANTITY";
    RefAuditCategory["RTSM_IpCodeReturnedAt"] = "RTSM::IP_CODE_RETURNED_AT";
    RefAuditCategory["RTSM_IpCodeReturnedQuantity"] = "RTSM::IP_CODE_RETURNED_QUANTITY";
    RefAuditCategory["RTSM_IpCodeUnReturnedQuantity"] = "RTSM::IP_CODE_UN_RETURNED_QUANTITY";
    RefAuditCategory["RTSM_IpCodeMetaData"] = "RTSM::IP_CODE_METADATA";
    RefAuditCategory["RTSM_IpCodeUpload"] = "RTSM:IP_CODE_UPLOAD";
    RefAuditCategory["RTSM_IpAutoDelivery"] = "RTSM:IP_AUTO_DELIVERY";
    RefAuditCategory["RTSM_IpAutoDeliveryCondition"] = "RTSM:IP_AUTO_DELIVERY_CONDITION";
    RefAuditCategory["RTSM_IpAutoDeliverySubCondition"] = "RTSM::IP_AUTO_DELIVERY_SUB_CONDITION";
    RefAuditCategory["RTSM_IpAutoDeliverySubConditionDetail"] = "RTSM::IP_AUTO_DELIVERY_SUB_CONDITION_DETAIL";
    RefAuditCategory["RTSM_IpAutoDeliveryRequest"] = "RTSM::IP_AUTO_DELIVERY_REQUEST";
    RefAuditCategory["RTSM_IpAutoDeliveryRequestDetail"] = "RTSM::IP_AUTO_DELIVERY_REQUEST_DETAIL";
    RefAuditCategory["RTSM_IpAutoDeliveryShippingPoint"] = "RTSM::IP_AUTO_DELIVERY_SHIPPING_POINT";
    RefAuditCategory["RTSM_IpDelivery"] = "RTSM:IP_DELIVERY";
    RefAuditCategory["RTSM_IpDeliveryDetail"] = "RTSM:IP_DELIVERY_DETAIL";
    RefAuditCategory["RTSM_IpDeliveryIpCodeDetail"] = "RTSM::IP_DELIVERY_IP_CODE_DETAIL";
    RefAuditCategory["RTSM_IpReturn"] = "RTSM::IP_RETURN";
    RefAuditCategory["RTSM_IpReturnDetail"] = "RTSM::IP_RETURN_DETAIL";
    RefAuditCategory["RTSM_StudyCustomComment"] = "RTSM::STUDY_CUSTOM_COMMENT";
    RefAuditCategory["RTSM_StudyComment"] = "RTSM::STUDY_COMMENT";
    RefAuditCategory["RTSM_StudyCustomQuery"] = "RTSM::STUDY_CUSTOM_QUERY";
    RefAuditCategory["RTSM_StudyQuery"] = "RTSM::STUDY_QUERY";
    RefAuditCategory["RTSM_NotificationEmail"] = "RTSM::NOTIFICATION_EMAIL";
    RefAuditCategory["RTSM_IpAccountabilityBySite"] = "RTSM::IP_ACCOUNTABILITY_BY_SITE";
    RefAuditCategory["RTSM_IpAccountabilityBySubject"] = "RTSM::IP_ACCOUNTABILITY_BY_SUBJECT";
    // Converter
    RefAuditCategory["Converter_User"] = "AUTH::USER";
    RefAuditCategory["Converter_Study"] = "CONVERTER::STUDY";
    RefAuditCategory["Converter_Import"] = "CONVERTER::IMPORT";
    RefAuditCategory["Converter_Dataset"] = "CONVERTER::DATASET";
    RefAuditCategory["Converter_DatasetVariable"] = "CONVERTER::DATASET_VARIABLE";
    RefAuditCategory["Converter_ConversionFactor"] = "CONVERTER::CONVERSION_FACTOR";
    RefAuditCategory["Converter_MyDictionary"] = "CONVERTER::MY_DICTIONARY";
    RefAuditCategory["Converter_DefineXml"] = "CONVERTER::DEFINE_XML";
    RefAuditCategory["Converter_Dataflow"] = "CONVERTER::DATA_FLOW";
    RefAuditCategory["Converter_Crf"] = "CONVERTER::CRF";
    RefAuditCategory["Converter_Validation"] = "CONVERTER::VALIDATION";
    RefAuditCategory["Converter_MembersMember"] = "CONVERTER::MEMBERS_MEMBER";
    RefAuditCategory["Converter_MembersRole"] = "CONVERTER::MEMBERS_ROLE";
    RefAuditCategory["Converter_Report"] = "CONVERTER::REPORT";
    RefAuditCategory["Converter_AdamDatasetVariable"] = "CONVERTER::ADAM_DATASET_VARIABLE";
})(RefAuditCategory = exports.RefAuditCategory || (exports.RefAuditCategory = {}));
var RefAuditReasonKey;
(function (RefAuditReasonKey) {
    RefAuditReasonKey["StudySubjectCreate"] = "STUDY_SUBJECT_CREATE";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessing"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSING";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessed"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSED";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToFail"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_FAIL";
    //
    RefAuditReasonKey["StudySubjectMigrate"] = "STUDY_SUBJECT_MIGRATE";
    RefAuditReasonKey["StudySubjectInit"] = "STUDY_SUBJECT_INIT";
    RefAuditReasonKey["StudySubjectVisitAdd"] = "STUDY_SUBJECT_VISIT_ADD";
    RefAuditReasonKey["StudySubjectVisitRemove"] = "STUDY_SUBJECT_VISIT_REMOVE";
    RefAuditReasonKey["StudySubjectVisitInit"] = "STUDY_SUBJECT_VISIT_INIT";
    RefAuditReasonKey["StudySubjectCrfInit"] = "STUDY_SUBJECT_CRF_INIT";
    RefAuditReasonKey["StudySubjectCrfEsignOn"] = "STUDY_SUBJECT_CRF_ESIGN_ON";
    RefAuditReasonKey["StudySubjectCrfEsignOff"] = "STUDY_SUBJECT_CRF_ESIGN_OFF";
    RefAuditReasonKey["StudySubjectCrfSecondEsignOn"] = "STUDY_SUBJECT_CRF_SECOND_ESIGN_ON";
    RefAuditReasonKey["StudySubjectCrfSecondEsignOff"] = "STUDY_SUBJECT_CRF_SECOND_ESIGN_OFF";
    RefAuditReasonKey["StudySubjectCrfPageAdd"] = "STUDY_SUBJECT_CRF_PAGE_ADD";
    //
    RefAuditReasonKey["StudySubjectSubjectNoUpdated"] = "STUDY_SUBJECT_SUBJECT_NO_UPDATED";
    RefAuditReasonKey["StudySubjectAllocated"] = "STUDY_SUBJECT_ALLOCATED";
    RefAuditReasonKey["StudySubjectRandomized"] = "STUDY_SUBJECT_RANDOMIZED";
    RefAuditReasonKey["StudySubjectAgeUpdated"] = "STUDY_SUBJECT_AGE_UPDATED";
    RefAuditReasonKey["StudySubjectSexUpdated"] = "STUDY_SUBJECT_SEX_UPDATED";
    RefAuditReasonKey["StudySubjectBirthDateUpdated"] = "STUDY_SUBJECT_BIRTH_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectIcfApprovedDateUpdated"] = "STUDY_SUBJECT_ICF_APPROVED_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectECoaAccessCodeUpdated"] = "STUDY_SUBJECT_ECOA_ACCESS_CODE_UPDATED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToNotAvailable"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_NOT_AVAILABLE";
    RefAuditReasonKey["StudySubjectStatusUpdatedToRegistration"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_REGISTRATION";
    RefAuditReasonKey["StudySubjectStatusUpdatedToEnrolled"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ENROLLED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreening"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreeningFailed"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING_FAILED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToOngoing"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ONGOING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToDroppedOut"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_DROPPED_OUT";
    RefAuditReasonKey["StudySubjectStatusUpdatedToCompleted"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_COMPLETED";
    RefAuditReasonKey["StudySubjectVisitDateUpdated"] = "STUDY_SUBJECT_VISIT_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectReservedUpdated"] = "STUDY_SUBJECT_RESERVED_UPDATED";
    RefAuditReasonKey["StudySubjectRandomizationNoDeleted"] = "STUDY_SUBJECT_RANDOMIZATION_NO_DELETED";
    //
    RefAuditReasonKey["StudySubjectEdcDataCaptured"] = "STUDY_SUBJECT_EDC_DATA_CAPTURED";
    RefAuditReasonKey["StudySubjectEdcDataStriked"] = "STUDY_SUBJECT_EDC_DATA_STRIKED";
    RefAuditReasonKey["StudySubjectEdcDataUnStriked"] = "STUDY_SUBJECT_EDC_DATA_UN_STRIKED";
    //
    RefAuditReasonKey["StudySubjectTriggerInvokeAllExplicitly"] = "STUDY_SUBJECT_TRIGGER_INVOKE_ALL_EXPLICITLY";
    RefAuditReasonKey["StudySubjectQueryDeprecated"] = "STUDY_SUBJECT_QUERY_DEPRECATED";
    RefAuditReasonKey["StudySubjectQueryAllowEmpty"] = "STUDY_SUBJECT_QUERY_ALLOW_EMPTY";
    RefAuditReasonKey["StudySubjectCrfRefresh"] = "STUDY_SUBJECT_CRF_REFRESH";
    //
    RefAuditReasonKey["StudySubjectEdcSdvAutoRelease"] = "STUDY_SUBJECT_EDC_SDV_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcEsignAutoRelease"] = "STUDY_SUBJECT_EDC_ESIGN_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcSecondEsignAutoRelease"] = "STUDY_SUBJECT_EDC_SECOND_ESIGN_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcReviewAutoRelease"] = "STUDY_SUBJECT_EDC_REVIEW_AUTO_RELEASE";
    //
    RefAuditReasonKey["StudySubjectSigningStatusChanged"] = "STUDY_SUBJECT_SIGNING_STATUS_CHANGED";
    //
    RefAuditReasonKey["StudySubjectUnblindRequest"] = "STUDY_SUBJECT_UNBLIND_REQUEST";
    RefAuditReasonKey["StudySubjectUnblindApprove"] = "STUDY_SUBJECT_UNBLIND_APPROVE";
    RefAuditReasonKey["StudySubjectUnblindForceUnderConds"] = "STUDY_SUBJECT_UNBLIND_FORCE_UNDER_CONDITIONS";
    RefAuditReasonKey["StudySubjectUnblindForce"] = "STUDY_SUBJECT_UNBLIND_FORCE";
    //
    RefAuditReasonKey["EcoaDataCaptured"] = "ECOA_DATA_CAPTURED";
    //
    RefAuditReasonKey["StudyIpDeliveryAutoRequested"] = "STUDY_IP_DELIVERY_AUTO_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryRequested"] = "STUDY_IP_DELIVERY_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryApproved"] = "STUDY_IP_DELIVERY_APPROVED";
    RefAuditReasonKey["StudyIpDeliveryStarted"] = "STUDY_IP_DELIVERY_STARTED";
    RefAuditReasonKey["StudyIpDeliveryCanceled"] = "STUDY_IP_DELIVERY_CANCELED";
    RefAuditReasonKey["StudyIpDeliveryConfirmed"] = "STUDY_IP_DELIVERY_CONFIRMED";
    //
    RefAuditReasonKey["StudyUsedIpReturnRequested"] = "STUDY_USED_IP_RETURN_REQUESTED";
    RefAuditReasonKey["StudyUsedIpReturnCanceled"] = "STUDY_USED_IP_RETURN_CANCELED";
    RefAuditReasonKey["StudyUsedIpReturnConfirmed"] = "STUDY_USED_IP_RETURN_CONFIRMED";
    RefAuditReasonKey["StudyUnusedIpReturnRequested"] = "STUDY_UNUSED_IP_RETURN_REQUESTED";
    RefAuditReasonKey["StudyUnusedIpReturnCanceled"] = "STUDY_UNUSED_IP_RETURN_CANCELED";
    RefAuditReasonKey["StudyUnusedIpReturnConfirmed"] = "STUDY_UNUSED_IP_RETURN_CONFIRMED";
    //
    RefAuditReasonKey["StudySubjectContactCreate"] = "STUDY_SUBJECT_CONTACT_CREATE";
    RefAuditReasonKey["StudySubjectContactUpdated"] = "STUDY_SUBJECT_CONTACT_UPDATED";
    RefAuditReasonKey["StudySubjectContactDeleted"] = "STUDY_SUBJECT_CONTACT_DELETED";
    //
    RefAuditReasonKey["StudySubjectCodingMigrated"] = "STUDY_SUBJECT_CODING_MIGRATED";
    //
    RefAuditReasonKey["StudySubjectCrfDisabled"] = "STUDY_SUBJECT_CRF_DISABLED";
    RefAuditReasonKey["StudySubjectCrfActivated"] = "STUDY_SUBJECT_CRF_ACTIVATED";
    RefAuditReasonKey["StudySubjectCrfVisited"] = "STUDY_SUBJECT_CRF_VISITED";
    RefAuditReasonKey["StudySubjectCrfUnVisited"] = "STUDY_SUBJECT_CRF_UNVISITED";
    //
    RefAuditReasonKey["StudySubjectCycleLikeVisitsAdded"] = "STUDY_SUBJECT_CYCLELIKE_VISITS_ADDED";
    RefAuditReasonKey["StudySubjectCycleLikeVisitsRemoved"] = "STUDY_SUBJECT_CYCLELIKE_VISITS_REMOVED";
    //
    RefAuditReasonKey["EsignSuccess"] = "ESIGN_SUCCESS";
    RefAuditReasonKey["EsignFail"] = "ESIGN_FAIL";
    //
    RefAuditReasonKey["StudyUatOpen"] = "STUDY_UAT_OPEN";
    RefAuditReasonKey["StudyUatClose"] = "STUDY_UAT_CLOSE";
    //
    RefAuditReasonKey["StudyUatSubmitted"] = "STUDY_UAT_SUBMITTED";
    RefAuditReasonKey["StudyUatAccepted"] = "STUDY_UAT_ACCEPTED";
    RefAuditReasonKey["StudyUatApplied"] = "STUDY_UAT_APPLIED";
    RefAuditReasonKey["StudyUatCompleted"] = "STUDY_UAT_COMPLETED";
    RefAuditReasonKey["StudyUatCanceled"] = "STUDY_UAT_CANCELED";
    RefAuditReasonKey["StudyUatAutoCanceled"] = "STUDY_UAT_AUTO_CANCELED";
    //
    RefAuditReasonKey["StudyUatMovedToNextSequence"] = "STUDY_UAT_MOVED_TO_NEXT_SEQUENCE";
    RefAuditReasonKey["StudyUatMigrated"] = "STUDY_UAT_MIGRATED";
    //
    RefAuditReasonKey["StudyUatCommentAdded"] = "STUDY_UAT_COMMENT_ADDED";
    RefAuditReasonKey["StudyUatCommentUpdated"] = "STUDY_UAT_COMMENT_UPDATED";
    RefAuditReasonKey["StudyUatCommentMigrated"] = "STUDY_UAT_COMMENT_MIGRATED";
    //
    RefAuditReasonKey["StudySubjectCrfAvailableStatusChanged"] = "STUDY_SUBJECT_CRF_AVAILABLE_STATUS_CHANGED";
    RefAuditReasonKey["StudySubjectCrfDisableStatusChanged"] = "STUDY_SUBJECT_CRF_DISABLE_STATUS_CHANGED";
    //
    RefAuditReasonKey["StudyLabTestAdded"] = "STUDY_LAB_TEST_ADDED";
    RefAuditReasonKey["StudyLabTestUpdated"] = "STUDY_LAB_TEST_UPDATED";
    RefAuditReasonKey["StudyLabTestDestroyed"] = "STUDY_LAB_TEST_DESTROYED";
    //
    RefAuditReasonKey["StudyLabNormalRangeAdded"] = "STUDY_LAB_NORMAL_RANGE_ADDED";
    RefAuditReasonKey["StudyLabNormalRangeUpdated"] = "STUDY_LAB_NORMAL_RANGE_UPDATED";
    //
    RefAuditReasonKey["StudyTrainingPageAdded"] = "STUDY_TRAINING_PAGE_ADDED";
    RefAuditReasonKey["StudyTrainingPageUpdated"] = "STUDY_TRAINING_PAGE_UPDATED";
    RefAuditReasonKey["StudyTrainingQuestionAdded"] = "STUDY_TRAINING_QUESTION_ADDED";
    RefAuditReasonKey["StudyTrainingQuestionUpdated"] = "STUDY_TRAINING_QUESTION_UPDATED";
    RefAuditReasonKey["StudyTrainingAnswerAdded"] = "STUDY_TRAINING_ANSWER_ADDED";
    RefAuditReasonKey["StudyTrainingAnswerUpdated"] = "STUDY_TRAINING_ANSWER_UPDATED";
    RefAuditReasonKey["StudyTrainingRenewalDelayed"] = "STUDY_TRAINING_RENEWAL_DELAYED";
    RefAuditReasonKey["StudyTrainingRenewalDelayInfoDestroyed"] = "STUDY_TRAINING_RENEWAL_DELAY_INFO_DESTROYED";
    //
    RefAuditReasonKey["StudyCustomDataCrfFileCreated"] = "STUDY_CUSTOM_DATA_CRF_FILE_CREATED";
    RefAuditReasonKey["StudyCustomDataCrfFileRequested"] = "STUDY_CUSTOM_DATA_CRF_FILE_REQUESTED";
    RefAuditReasonKey["StudyCustomDataCrfFileDownloaded"] = "STUDY_CUSTOM_DATA_CRF_FILE_DOWNLOADED";
    //
    RefAuditReasonKey["StudyDuplicatedCrfPageDestroyed"] = "STUDY_DUPLICATED_CRF_PAGE_DESTROYED";
    //
    RefAuditReasonKey["StudyDataIntegrationAttachmentFileCaptured"] = "STUDY_DATA_INTEGRATION_ATTACHMENT_FILE_CAPTURED";
    //
    RefAuditReasonKey["StudyIpCodeAllocated"] = "STUDY_IP_CODE_ALLOCATED";
    RefAuditReasonKey["StudyIpCodeRetrieved"] = "STUDY_IP_CODE_RETRIEVED";
    //
    RefAuditReasonKey["StudyCaptureStatusBulkCrfEsign"] = "STUDY_CAPTURE_STATUS_BULK_CRF_ESIGN";
    //
    RefAuditReasonKey["StudyIndependentEvaluationCrfInit"] = "STUDY_INDEPENDENT_EVALUATION_CRF_INIT";
})(RefAuditReasonKey = exports.RefAuditReasonKey || (exports.RefAuditReasonKey = {}));
//# sourceMappingURL=resource.js.map